import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { FormikTextField } from 'src/components/shared/form/formik/FormikTextField'
import type { DocusignTemplateFormValues } from './DocusignTemplateForm.interface'

const DOCUSIGN_ID_HINT = 'Find this in DocuSign → Templates → the template’s Template ID.'

const DocusignTemplateFormContentComponent = () => {
  return (
    <div css={tw`flex flex-col gap-4`}>
      <FormikTextField<DocusignTemplateFormValues>
        name="title"
        label="Title"
        placeholder="e.g. Independent Contractor Agreement"
      />
      <FormikTextField<DocusignTemplateFormValues>
        name="description"
        label="Description"
        placeholder="Optional"
      />
      <div>
        <FormikTextField<DocusignTemplateFormValues>
          name="docusignId"
          label="DocuSign ID"
          placeholder="Paste the template ID from DocuSign"
        />
        <Typography variant="body2" css={tw`mt-1 text-shades-500`}>
          {DOCUSIGN_ID_HINT}
        </Typography>
      </div>
    </div>
  )
}

export const DocusignTemplateFormContent = memo(DocusignTemplateFormContentComponent)
